// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__SCH52","text":"Loader_text__GZ9Xy","IdsRoller":"Loader_IdsRoller__nw4RY"};